var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "worklist-action-table" },
    [
      _c("div", { staticClass: "mb-10" }, [
        _c(
          "div",
          {
            staticClass:
              "disp-flex flex-wrap align-items-center justify-content-between"
          },
          [
            _c(
              "div",
              { staticClass: "disp-flex flex-wrap align-items-center" },
              [
                _c(
                  "span",
                  { staticClass: "mr-20 mb-10" },
                  [
                    _c("strong", [
                      _vm._v(" " + _vm._s(_vm.$t("status")) + ": ")
                    ]),
                    _vm._v(" "),
                    _c(
                      "el-select",
                      {
                        staticClass: "mr-10",
                        attrs: {
                          size: "mini",
                          multiple: "",
                          "collapse-tags": ""
                        },
                        model: {
                          value: _vm.statusFilter,
                          callback: function($$v) {
                            _vm.statusFilter = $$v
                          },
                          expression: "statusFilter"
                        }
                      },
                      _vm._l(_vm.STATUS_FILTERS, function(filter) {
                        return _c("el-option", {
                          key: filter.value,
                          attrs: {
                            label: _vm.$translate.action_status(filter.value),
                            value: filter.value
                          }
                        })
                      }),
                      1
                    )
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "span",
                  { staticClass: "mr-20 mb-10" },
                  [
                    _c("strong", [
                      _vm._v(" " + _vm._s(_vm.$t("period")) + ": ")
                    ]),
                    _vm._v(" "),
                    _c("el-date-picker", {
                      attrs: {
                        size: "mini",
                        type: "daterange",
                        align: "right",
                        "unlink-panels": "",
                        "range-separator": "-",
                        "start-placeholder": _vm.$t("startDate"),
                        "end-placeholder": _vm.$t("endDate"),
                        format: "yyyy-MM-dd",
                        "value-format": "yyyy-MM-dd"
                      },
                      model: {
                        value: _vm.dateRange,
                        callback: function($$v) {
                          _vm.dateRange = $$v
                        },
                        expression: "dateRange"
                      }
                    })
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "span",
                  { staticClass: "mr-20 mb-10" },
                  [
                    _c("strong", [
                      _vm._v(" " + _vm._s(_vm.$t("assignee")) + ": ")
                    ]),
                    _vm._v(" "),
                    _c(
                      "el-select",
                      {
                        staticClass: "mr-10",
                        attrs: { size: "mini" },
                        model: {
                          value: _vm.assigneeFilter,
                          callback: function($$v) {
                            _vm.assigneeFilter = $$v
                          },
                          expression: "assigneeFilter"
                        }
                      },
                      [
                        _c("el-option", {
                          attrs: {
                            label: _vm.$t("WorklistTable.all"),
                            value: null
                          }
                        }),
                        _vm._v(" "),
                        _c("el-option", {
                          attrs: {
                            label: _vm.$t("WorklistTable.unassigned"),
                            value: "UNASSIGNED"
                          }
                        }),
                        _vm._v(" "),
                        _vm._l(_vm.assigneeOptions, function(user) {
                          return _c("el-option", {
                            key: user.value,
                            attrs: { label: user.label, value: user.value }
                          })
                        })
                      ],
                      2
                    )
                  ],
                  1
                ),
                _vm._v(" "),
                _vm.worklistExecutionType !== "AUTOMATED"
                  ? _c(
                      "span",
                      { staticClass: "mr-20 mb-10" },
                      [
                        _c(
                          "el-checkbox",
                          {
                            attrs: { value: _vm.groupVars.showManualActions },
                            on: { change: _vm.handleShowManualActionsChange }
                          },
                          [
                            _vm._v(
                              "\n\t\t\t\t\t\t" +
                                _vm._s(
                                  _vm.$t("ActionTable.showManualActions")
                                ) +
                                "\n\t\t\t\t\t\t"
                            ),
                            _c(
                              "el-tooltip",
                              {
                                attrs: {
                                  placement: "top",
                                  content: _vm.$t(
                                    "validator.action.phone.cannot_be_executed_in_bulk"
                                  )
                                }
                              },
                              [
                                _c("i", {
                                  staticClass: "el-icon-warning-outline"
                                })
                              ]
                            )
                          ],
                          1
                        )
                      ],
                      1
                    )
                  : _vm._e(),
                _vm._v(" "),
                _c("span", { staticClass: "mr-20 mb-10" }, [
                  !_vm.isDirty
                    ? _c(
                        "div",
                        { staticClass: "inl-bl" },
                        [
                          _c(
                            "el-tooltip",
                            {
                              staticClass: "item",
                              attrs: {
                                effect: "dark",
                                content: _vm.$t("refreshList"),
                                placement: "top"
                              }
                            },
                            [
                              _c(
                                "el-button",
                                {
                                  attrs: {
                                    disabled: _vm.loading,
                                    type: "primary",
                                    size: "mini"
                                  },
                                  on: { click: _vm.handleRefreshList }
                                },
                                [
                                  _c("svg-icon", {
                                    staticClass: "fc-white fs-11",
                                    attrs: { "icon-class": "sync-alt-solid" }
                                  })
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.isDirty
                    ? _c(
                        "div",
                        { staticClass: "inl-bl" },
                        [
                          _c(
                            "el-button",
                            {
                              attrs: {
                                disabled: _vm.loading,
                                type: "primary",
                                size: "mini"
                              },
                              on: { click: _vm.handleFilter }
                            },
                            [
                              _vm._v(
                                "\n\t\t\t\t\t\t\t" +
                                  _vm._s(_vm.$t("applyFilters")) +
                                  "\n\t\t\t\t\t\t"
                              )
                            ]
                          )
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "inl-bl" },
                    [
                      _c(
                        "el-button",
                        {
                          attrs: { disabled: _vm.loading, size: "mini" },
                          on: { click: _vm.handleReset }
                        },
                        [
                          _vm._v(
                            "\n\t\t\t\t\t\t\t" +
                              _vm._s(_vm.$t("reset")) +
                              "\n\t\t\t\t\t\t"
                          )
                        ]
                      )
                    ],
                    1
                  )
                ])
              ]
            ),
            _vm._v(" "),
            _c(
              "el-dropdown",
              {
                staticClass: "mb-10",
                attrs: { size: "mini", disabled: _vm.loading },
                on: { command: _vm.handleExport }
              },
              [
                _c(
                  "el-button",
                  { attrs: { size: "mini", disabled: _vm.loading } },
                  [
                    _c("i", { staticClass: "el-icon-download" }),
                    _vm._v(" " + _vm._s(_vm.$t("export")) + " "),
                    _c("i", {
                      staticClass: "el-icon-arrow-down el-icon--right"
                    })
                  ]
                ),
                _vm._v(" "),
                _c(
                  "el-dropdown-menu",
                  { attrs: { slot: "dropdown" }, slot: "dropdown" },
                  [
                    _c("el-dropdown-item", { attrs: { command: "csv" } }, [
                      _vm._v(_vm._s(_vm.$t("ActionTable.exportCsv")))
                    ]),
                    _vm._v(" "),
                    _c("el-dropdown-item", { attrs: { command: "excel" } }, [
                      _vm._v(_vm._s(_vm.$t("ActionTable.exportExcel")))
                    ])
                  ],
                  1
                )
              ],
              1
            )
          ],
          1
        )
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "disp-flex justify-content-between" }, [
        _c(
          "div",
          { staticClass: "mb-10" },
          [
            _c(
              "loading-button",
              {
                attrs: {
                  type: "success",
                  size: "mini",
                  disabled:
                    !_vm.selectedActions ||
                    _vm.selectedActions.length < 1 ||
                    _vm.executing ||
                    _vm.selectedActions.some(item => item.status !== "OPEN"),
                  loading: _vm.executing,
                  execute: _vm.handleSelectedActions
                }
              },
              [
                _vm._v(
                  "\n\t\t\t\t" +
                    _vm._s(_vm.$t("executeSelectedActions")) +
                    "\n\t\t\t"
                )
              ]
            ),
            _vm._v(" "),
            _c(
              "loading-button",
              {
                attrs: {
                  type: "warning",
                  size: "mini",
                  disabled:
                    !_vm.selectedActions ||
                    _vm.selectedActions.length < 1 ||
                    _vm.executing ||
                    _vm.selectedActions.some(item => item.status !== "OPEN"),
                  loading: _vm.executing,
                  execute: _vm.cancelSelectedActions
                }
              },
              [
                _vm._v(
                  "\n\t\t\t\t" +
                    _vm._s(_vm.$t("cancelSelectedActions")) +
                    "\n\t\t\t"
                )
              ]
            ),
            _vm._v(" "),
            _c(
              "loading-button",
              {
                attrs: {
                  type: "danger",
                  size: "mini",
                  disabled:
                    !_vm.selectedActions ||
                    _vm.selectedActions.length < 1 ||
                    _vm.executing ||
                    _vm.selectedActions.some(item => item.status !== "DRAFT"),
                  loading: _vm.executing,
                  execute: _vm.forceOpenSelectedActions
                }
              },
              [
                _vm._v(
                  "\n\t\t\t\t" +
                    _vm._s(_vm.$t("forcedOpenSelectedActions")) +
                    "\n\t\t\t"
                )
              ]
            ),
            _vm._v(" "),
            _c(
              "loading-button",
              {
                attrs: {
                  type: "danger",
                  size: "mini",
                  disabled:
                    !_vm.selectedActions ||
                    _vm.selectedActions.length < 1 ||
                    _vm.executing ||
                    _vm.selectedActions.some(item => item.status !== "DRAFT"),
                  loading: _vm.executing,
                  execute: _vm.forceCancelSelectedActions
                }
              },
              [
                _vm._v(
                  "\n\t\t\t\t" +
                    _vm._s(_vm.$t("forcedCancelSelectedActions")) +
                    "\n\t\t\t"
                )
              ]
            )
          ],
          1
        ),
        _vm._v(" "),
        _c("div", { staticClass: "mb-10 fs-14" }, [
          _c("div", { staticClass: "mb-3" }, [
            _c("span", { staticClass: "fw-b text-color--dark-gray" }, [
              _vm._v(_vm._s(_vm.$t("ActionTable.actions")))
            ]),
            _vm._v(" "),
            _c("span", { staticClass: "text-color--gray ml-5" }, [
              _vm._v(
                "(" +
                  _vm._s(
                    _vm.actualCount < _vm.limit
                      ? _vm.actualCount
                      : _vm.limit + "+"
                  ) +
                  ")"
              )
            ])
          ]),
          _vm._v(" "),
          _vm.showLimitWarning
            ? _c(
                "div",
                { staticClass: "fs-13" },
                [
                  _vm._v(
                    "\n\t\t\t\t" +
                      _vm._s(
                        _vm.$t("ActionTable.limitInfoMessage", {
                          limit: _vm.limit
                        })
                      ) +
                      "\n\t\t\t\t"
                  ),
                  _c(
                    "el-link",
                    {
                      staticClass: "ml-5",
                      attrs: {
                        type: "primary",
                        underline: false,
                        disabled: _vm.loading
                      },
                      on: { click: _vm.increaseLimitAndFetch }
                    },
                    [
                      _vm._v(
                        "\n\t\t\t\t\t" +
                          _vm._s(_vm.$t("ActionTable.loadMore")) +
                          "\n\t\t\t\t"
                      )
                    ]
                  )
                ],
                1
              )
            : _vm._e()
        ])
      ]),
      _vm._v(" "),
      _c("attachments-dialog", {
        attrs: {
          participant: _vm.$store.state.risolto.selectedParticipantStore,
          "legal-entity": _vm.attachmentsDialogAction?.legal_entity || "",
          visible: _vm.attachmentsDialogVisible,
          "file-list": _vm.attachmentsDialogFileList,
          "on-upload": _vm.handleAttachmentUpload,
          "on-remove": _vm.handleAttachmentRemove
        },
        on: {
          "dialog-close": function($event) {
            _vm.attachmentsDialogVisible = false
          }
        }
      }),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "worklist-action-table__grid-wrapper",
          staticStyle: { position: "relative", "z-index": "0" }
        },
        [
          _c("rslt-ag-grid", {
            attrs: {
              "group-display-type": "multipleColumns",
              "row-group-panel-show": "always",
              "group-default-expanded": 1,
              "group-selects-children": true,
              "group-selects-filtered": true,
              "grid-key": "action-table-WORKLIST",
              "column-defs": _vm.columnDefs,
              "row-data": _vm.initialRowData,
              "get-row-id": _vm.getRowId,
              loading: _vm.loading,
              "row-selection": "multiple",
              "grid-class": "worklist-action-table-grid",
              "side-bar": _vm.sideBar,
              "status-bar": _vm.statusBar,
              "get-row-class": _vm.getRowClass
            },
            on: {
              "selection-changed": _vm.handleSelectionChange,
              "grid-ready": _vm.onGridReady,
              "row-clicked": _vm.onRowClicked
            }
          }),
          _vm._v(" "),
          _vm.isDirty
            ? _c(
                "div",
                {
                  staticStyle: {
                    "background-color": "rgba(235, 236, 240, 0.8)",
                    position: "absolute",
                    top: "0",
                    left: "0",
                    height: "100%",
                    width: "100%",
                    display: "flex",
                    "justify-content": "center",
                    "align-items": "center",
                    "z-index": "2"
                  }
                },
                [
                  _c(
                    "div",
                    {
                      staticStyle: {
                        display: "flex",
                        "align-items": "center",
                        "flex-direction": "column"
                      }
                    },
                    [
                      _c(
                        "div",
                        {
                          staticStyle: {
                            "font-weight": "bold",
                            "margin-bottom": "10px"
                          }
                        },
                        [_vm._v(_vm._s(_vm.$t("general.press_apply_filter")))]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticStyle: { display: "inline-flex", gap: "10px" }
                        },
                        [
                          _c(
                            "el-button",
                            {
                              attrs: {
                                disabled: _vm.loading,
                                type: "primary",
                                size: "mini"
                              },
                              on: { click: _vm.handleFilter }
                            },
                            [_vm._v(_vm._s(_vm.$t("applyFilters")))]
                          ),
                          _vm._v(" "),
                          _c(
                            "el-button",
                            {
                              attrs: {
                                disabled: _vm.loading,
                                type: "text",
                                size: "mini"
                              },
                              on: { click: _vm.undoChanges }
                            },
                            [_vm._v(_vm._s(_vm.$t("general.undo_changes")))]
                          )
                        ],
                        1
                      )
                    ]
                  )
                ]
              )
            : _vm._e()
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }